var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9923 14.2149C15.4102 14.2149 15.75 14.5592 15.75 14.9825C15.75 15.4065 15.4102 15.75 14.9923 15.75H10.7098C10.2919 15.75 9.9521 15.4065 9.9521 14.9825C9.9521 14.5592 10.2919 14.2149 10.7098 14.2149H14.9923ZM12.0224 2.7743L13.1286 3.65309C13.5823 4.00783 13.8847 4.47544 13.9882 4.96724C14.1076 5.50822 13.9802 6.03953 13.6221 6.49908L7.0323 15.0209C6.72987 15.4079 6.28418 15.6256 5.80666 15.6337L3.1803 15.6659C3.03704 15.6659 2.91766 15.5692 2.88582 15.4321L2.28892 12.8441C2.18546 12.3684 2.28892 11.8766 2.59135 11.4977L7.2631 5.45098C7.34269 5.35423 7.48594 5.33891 7.58145 5.41067L9.54724 6.97475C9.67458 7.07956 9.84967 7.136 10.0327 7.11181C10.4227 7.06344 10.6853 6.7087 10.6455 6.32977C10.6217 6.13628 10.5262 5.97503 10.3988 5.85409C10.359 5.82185 8.48874 4.32226 8.48874 4.32226C8.36936 4.22551 8.34548 4.04814 8.44099 3.92801L9.18114 2.96779C9.86559 2.089 11.0594 2.00838 12.0224 2.7743Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0278942f.svg";
export { ForwardRef as ReactComponent };